import {put, takeLatest, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {get} from 'lodash';
import {
  fetchOwnerCorporateListRequest,
  fetchOwnerCorporateListSuccess,
  fetchOwnerCorporateListError,
} from './index';
import {fetchOwnerCorporateList} from './api';

export const sagaActions = {
  FETCH_OWNER_CORPORATE_LIST: 'FETCH_OWNER_CORPORATE_LIST',
};

function* fetchOwnerCorporateListSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchOwnerCorporateListRequest());
    const result = yield call(fetchOwnerCorporateList, values);
    if (!result.error) {
      yield put(
        fetchOwnerCorporateListSuccess({
          data: result.data.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      toast.error(result.error);
      yield put(
        fetchOwnerCorporateListSuccess({
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchOwnerCorporateListError(message));
    } else {
      toast.error(e.error);
      yield put(fetchOwnerCorporateListError(e.error));
    }
  }
}

function* rootSagas() {
  yield takeLatest(
    sagaActions.FETCH_OWNER_CORPORATE_LIST,
    fetchOwnerCorporateListSaga
  );
}

export default rootSagas;
